import { haveSameElements } from "app/pages/sales-intelligence/utils/arrays";
import { buildInclusionConditionKey } from "app/pages/sales-intelligence/utils/inclusionConditionKey";

import type { TechnologiesFilterDto } from "../types/filter-values";

export const getTechnologyConditionKey = (item: TechnologiesFilterDto): string =>
    buildInclusionConditionKey(item.inclusion, item.categories, item.parentCategories, item.technologies);

export const hasSameTechnologyObject = (
    item: TechnologiesFilterDto,
    comparedItem: TechnologiesFilterDto | null,
): boolean => {
    if (comparedItem === null) {
        return false;
    }

    return (
        item.inclusion === comparedItem.inclusion &&
        haveSameElements(item.categories, comparedItem.categories) &&
        haveSameElements(item.parentCategories, comparedItem.parentCategories) &&
        haveSameElements(item.technologies, comparedItem.technologies)
    );
};
